import type { FC } from "react";
import { useEffect } from "react";

import { type ITelemetryCustom, sendTelemetryEvent } from "@/lib/telemetry";
import { TransitionLink } from "@/src/common/Transition";
import ImageLoader from "@Components/ImageLoader";
import { LinkAppearance } from "@Components/Link";

import * as cssPortal from "../../shared/Portal.module.css";
import * as css from "./Cta.module.css";

export type ICta = {
    title: string;
    description: string;
    image: string;
    navigateUrl?: string;
    buttonText?: string;
    trackingUrlCustom?: ITelemetryCustom;
    clickTrackingUrlCustom?: ITelemetryCustom;
    onClick?: () => boolean | void;
};

const Cta: FC<ICta> = (props) => {
    useEffect(() => {
        sendTelemetryEvent(props.trackingUrlCustom);
    }, []);

    const ctaBtnClick = () => {
        sendTelemetryEvent(props.clickTrackingUrlCustom);

        props.onClick?.();

        return true;
    };

    return (
        <div className={`${css.ctaComponent} ${cssPortal.standardContainerV2}`}>
            <div className={css.wrapper}>
                <ImageLoader src={props.image} />
                <p className={css.title}>{props.title}</p>
                <p className={css.description} dangerouslySetInnerHTML={{ __html: props.description }} />
                <TransitionLink
                    className={css.btn}
                    appearance={LinkAppearance.ButtonMagentaRound}
                    text={props.buttonText}
                    navigateUrl={props.navigateUrl}
                    onClick={ctaBtnClick}
                />
            </div>
        </div>
    );
};

export default Cta;
